<template>
    <a-modal
      :title="isAdd ? '新建资讯' : '修改资讯'"
      :maskClosable="false"
      :width="1040"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @ok="handleSubmit"
      @cancel="handleCancel"
    >
      <a-form layout="horizontal" :form="form" class="po-inner">
        <!-- 资讯标题 -->
        <a-form-item
          label="资讯标题"
          :labelCol="{ lg: { span: 5 } }"
          :wrapperCol="{ lg: { span: 6 } }"
        >
          <a-input
            type="text"
            placeholder="请输入"
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请输入资讯标题' }],
                validateTrigger: 'change',
              },
            ]"
          />
        </a-form-item>
  
        <!-- 新闻类型 -->
        <a-form-item
          label="新闻类型"
          :labelCol="{ lg: { span: 5 } }"
          :wrapperCol="{ lg: { span: 6 } }"
        >
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-decorator="[
              'type',
              {
                rules: [{ required: true, message: '请选择资讯类型' }],
                validateTrigger: 'change',
              },
            ]"
          >
            <a-select-option v-for="(item, index) in portalTypeList" :value="item.id" :key="index">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
  
        <!-- 资讯封面 -->
        <a-form-item
          class="upload-item"
          label="上传照片"
          :labelCol="{ lg: { span: 5 } }"
          :wrapperCol="{ lg: { span: 18 } }"
        >
          <div class="check-icon">*</div>
          <c-upload
            ossType="avatar"
            ref="coverUpload"
            :isSingle="true"
            accept="image/*"
            @uploadSuccess="uploadSuccess"
            :sourceFileList="sourceFileList"
          ></c-upload>
        </a-form-item>
  
        <a-form-item
          label="资讯内容"
          :labelCol="{ lg: { span: 5 } }"
          :wrapperCol="{ lg: { span: 18 } }"
        >
          <!-- <a-textarea
            type="text"
            class="textarea-input"
            placeholder="请输入"
            v-decorator="[
              'content',
              {rules: [{ required: true, message: '请输入资讯类型' }], validateTrigger: 'change'}
            ]"
          /> -->
          <c-richtext :editorContent.sync="editorContent"></c-richtext>
        </a-form-item>
      </a-form>
    </a-modal>
  </template>
  
  <script>
  import news from '../../api/news'
  
  import CUpload from '../../components/CUpload'
  
  import CRichtext from '../../components/CRichtext'
  
  export default {
    name: 'personFormModal',
    data() {
      return {
        form: this.$form.createForm(this),
        isAdd: true, //是否是新增person
        newsId: -1,
        visible: false,
        updateData: {},
        confirmLoading: false,
        coverUrl: '',
        sourceFileList: [],
        portalTypeList: [
          { id: '1', name: '新闻动态' },
          { id: '2', name: '通知公告' },
        ],
        editorContent: '', //编辑器内容
      }
    },
    components: {
      CUpload,
      CRichtext,
    },
    methods: {
      //头像上传成功之后回调
      uploadSuccess(url) {
        this.coverUrl = url
      },
  
      //初始化，显示
      init(type, params) {
        this.visible = true
        this.isAdd = type === 'add' ? true : false
  
        //初始化form表单数据
        if (params) {
          this.updateData = params
          let formData = {}
          formData.title = params.title
          formData.type = params.type ? params.type.toString() : ''
          this.editorContent = params.content
          this.sourceFileList = [params.coverUrl]
          this.newsId = params.id
          setTimeout(() => {
            this.form.setFieldsValue(formData)
          }, 100)
        } else {
          this.sourceFileList = []
          this.form.resetFields()
        }
      },
  
      //隐藏
      handleCancel() {
        this.visible = false
        this.$emit('closeForm')
      },
  
      //新增一个人员
      handleSubmit(e) {
        e.preventDefault()
        this.$refs['coverUpload'].check().then(res => {
          if (res) {
            this.form.validateFields((err, value) => {
              console.log('输入的内容是：', value)
              //校验通过
              if (!err) {
                value.content = this.editorContent
                value.coverUrl = this.coverUrl
                if (this.isAdd) {
                  this.addNews(value)
                } else {
                  this.updateNews(value)
                }
              }
            })
          }
        })
      },
  
      //新增人员
      addNews(value) {
        news.createNews(value).then(res => {
          this.$message.success('新增成功')
          this.handleCancel()
          this.$emit('refreshNews')
        })
      },
  
      updateNews(value) {
        news.updateNews(this.newsId, value).then(res => {
          this.$message.success('修改成功')
          Object.assign(this.updateData, value)
          this.handleCancel()
        })
      },
    },
  }
  </script>
  <style lang="less" scoped>
  .po-inner {
    height: calc(100vh - 300px);
    overflow: auto;
  }
  .cl-inner {
    width: calc(100% - 40px);
    padding: 50px 20px 30px;
    background: white;
    margin: 20px auto;
  }
  .ap-form {
    width: 400px;
  }
  .form-oper {
    text-align: center;
    button {
      margin: 0px 5px;
    }
  }
  .textarea-input {
    height: 200px;
  }
  .upload-item {
    position: relative;
  }
  .check-icon {
    position: absolute;
    top: 0px;
    left: -79px;
    font-size: 16px;
    color: #f5222d;
  }
  </style>
  